import { OnInit } from '@angular/core';
import { QuestionSet } from '../../shared/models/question-set';
var QuestionSetCoreFormComponent = /** @class */ (function () {
    function QuestionSetCoreFormComponent() {
    }
    QuestionSetCoreFormComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(QuestionSetCoreFormComponent.prototype, "QuestionSet", {
        get: function () {
            return this.questionSet;
        },
        set: function (v) {
            this.questionSet = v;
        },
        enumerable: true,
        configurable: true
    });
    return QuestionSetCoreFormComponent;
}());
export { QuestionSetCoreFormComponent };



// WEBPACK FOOTER //
// ./src/app/admin/question-set-core-form/question-set-core-form.component.ts.pre-build-optimizer.js